import React, { useRef } from 'react';
import HiddenGridRow from './HiddenGridRow';
import { useRowVisibility } from '../../Torpedo/BaseTorpedo/hooks/useRowVisibility';
import VisibleGridRow from './VisibleGridRow';
import OffsetTracking from '../../Torpedo/BaseTorpedo/_partials/OffsetTracking';
import LazyContext from '../../LazyLoadingImage/LazyContext';
import { LAZYLOAD_ROW_START } from '../../types';
const GridRow = ({ start , end , elementWidth , elementHeight , elementSpacing , scrollOptims , contentStrip , rowIdx , withShadowSpace , renderElement , getDuperbrowseItemId , onOffsetReached , rowAlign  })=>{
    const ref = useRef(null);
    const isVisible = useRowVisibility(ref, {
        enabled: scrollOptims
    });
    let rowStyle = {};
    if (rowAlign) {
        const settingToCss = {
            left: 'flex-start',
            right: 'flex-end',
            center: 'center'
        };
        rowStyle = {
            display: 'flex',
            justifyContent: settingToCss[rowAlign]
        };
    }
    return /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: rowIdx >= LAZYLOAD_ROW_START
    }, /*#__PURE__*/ React.createElement(OffsetTracking, {
        rowIdx: rowIdx,
        onOffsetReached: onOffsetReached
    }, /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        style: rowStyle
    }, contentStrip, isVisible ? /*#__PURE__*/ React.createElement(VisibleGridRow, {
        start: start,
        end: end,
        elementWidth: elementWidth,
        elementHeight: elementHeight,
        elementSpacing: elementSpacing,
        withShadowSpace: withShadowSpace,
        renderElement: renderElement
    }) : /*#__PURE__*/ React.createElement(HiddenGridRow, {
        start: start,
        end: end,
        getDuperbrowseItemId: getDuperbrowseItemId,
        marginTop: elementSpacing,
        height: elementHeight
    }))));
};
GridRow.displayName = 'GridRow';
export default GridRow;
